<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'app'
  }
</script>

<style lang="scss" rel="stylesheet/scss">
  @import 'assets/scss/common.scss';

  html,
  body{
    height: 100%;
  }
  #app{
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    min-width: 900px;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// App.vue?9ca124da